import React from 'react';
import './FaisalContactInfo.css';

const FaisalContactInfo = () => {
  return (
    <section className="faisal-contact-section">
      <div className="faisal-contact-container">
        <div className="faisal-contact-header">
          <h2>Get in <span className="highlight">Touch</span> with Faisal</h2>
          <p>Ready to discuss your project or have questions? Reach out directly!</p>
        </div>

        <div className="contact-info-card">
          <div className="profile-section">
            <div className="profile-image">
              <div className="profile-placeholder">
                <span>X</span>
              </div>
            </div>
            <div className="profile-details">
              <h3>Eng. Faisal A Samad</h3>
            </div>
          </div>

          <div className="contact-details">
            <div className="contact-item">
              <div className="contact-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
              </div>
              <div className="contact-info">
                <label>Email</label>
                <a href="mailto:faisal@skriptdev.com" className="contact-link">faisal@skriptdev.com</a>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
              </div>
              <div className="contact-info">
                <label>Phone</label>
                <a href="tel:+96103074628" className="contact-link">+961 03 074 628</a>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
              </div>
              <div className="contact-info">
                <label>Location</label>
                <span className="contact-text">Beirut - Lebanon</span>
              </div>
            </div>

          </div>

          <div className="quick-actions">
            <div className="action-buttons">
              <a href="mailto:faisal@skriptdev.com" className="action-btn primary">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
                Send Email
              </a>
              <a href="tel:+96103074628" className="action-btn secondary">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                Call Now
              </a>
            </div>
          </div>
        </div>

        <div className="contact-decoration">
          <div className="decoration-circle orange"></div>
          <div className="decoration-circle pink"></div>
          <div className="decoration-dots"></div>
        </div>
      </div>
    </section>
  );
};

export default FaisalContactInfo;
